// extracted by mini-css-extract-plugin
export default {"icon":"ServicesCardSection_icon__C+1BF","icon-installed":"ServicesCardSection_icon-installed__hFchV","description-installed":"ServicesCardSection_description-installed__IuAaf"};